import { NavigateFunction } from "react-router";
import { BaseButton } from "../../../atoms/BaseButton";
import "../homeStyles.css";

interface Props {
  navigate: NavigateFunction;
}

export const ToPortfolio = ({ navigate }: Props) => {
  return (
    <div>
      <div className="text-container">
        <div className="right-to-left text-5xl">
          <p>PERSONAL PORTFOLIO</p>
          <p>-</p>
          <p>PERSONAL PORTFOLIO</p>
          <p>-</p>
          <p>PERSONAL PORTFOLIO</p>
          <p>-</p>
          <p>PERSONAL PORTFOLIO</p>
          <p>-</p>
          <p>PERSONAL PORTFOLIO</p>
        </div>
      </div>
      <div className="relative">
        <img
          className="mr-10 max-h-screen w-full bg-cover bg-center bg-no-repeat"
          src={
            "/photos/home/bottom_to_portfolio_picture/bottom_to_portfolio_picture.jpg"
          }
          alt="logo"
          loading="lazy"
        />
        <BaseButton
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-lg"
          onClick={() => navigate("/portfolio")}
        >
          Portfolio
        </BaseButton>
      </div>
    </div>
  );
};
